import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the SvgProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class SvgProvider {

  private spiderparameters: string[] = ['fruity', 'malty', 'sweet', 'sour', 'bitter', 'hoppy'];
  private spiderindex: number[] = new Array(0, 0, 0, 0, 0, 0);
  private spidercorners: any[] = new Array({ x: 0, y: 0 }, { x: 0, y: 0 }, { x: 0, y: 0 }, { x: 0, y: 0 }, { x: 0, y: 0 }, { x: 0, y: 0 });

  constructor() {
    for (let k = 0; k < this.spiderparameters.length; k++) {
      this.spiderindex[this.spiderparameters[k]] = k;
    }
  }

  private generateSpiderCorners(radiusList, center) {
    for (let k = 0; k < radiusList.length; k++) {
      var radius = radiusList[k];
      var corners = [
        { x: center.x - radius, y: center.y },
        { x: center.x - radius / 2, y: center.y - radius * Math.sin(60 * Math.PI / 180.0) },
        { x: center.x + radius / 2, y: center.y - radius * Math.sin(60 * Math.PI / 180.0) },
        { x: center.x + radius, y: center.y },
        { x: center.x + radius / 2, y: center.y + radius * Math.sin(60 * Math.PI / 180.0) },
        { x: center.x - radius / 2, y: center.y + radius * Math.sin(60 * Math.PI / 180.0) }
      ];
      this.spidercorners[k] = corners;
    }
  }
  public generateSpider(analysis, topOffset, leftOffset, fullViewPortWidth, fullViewPortHeight): any {
    let viewPortWidth: number = Math.trunc(1.0 * fullViewPortWidth);
    let viewPortHeight: number = Math.trunc(1.0 * fullViewPortHeight);

    var spiderRadius = Math.min(viewPortHeight, viewPortWidth) / 2.55;

    var center = { x: viewPortWidth / 2, y: viewPortHeight / 2 };
    var radiusList = [spiderRadius / 5, 2 * spiderRadius / 5, 3 * spiderRadius / 5, 4 * spiderRadius / 5, spiderRadius];

    this.generateSpiderCorners(radiusList, center);

    var mySvgHexagons = this.generateSpiderHexagons(radiusList, viewPortHeight, viewPortWidth, spiderRadius, center);

    var mySvgSpiderContours = this.generateSpiderContours(viewPortHeight, viewPortWidth);

    var mySvgSpiderContents = this.generateSpiderContents(analysis, viewPortHeight, viewPortWidth);

    var mySvgSpiderTouchOverlay = this.generateSpiderTouchOverlay(radiusList, viewPortHeight, viewPortWidth, spiderRadius, center);

    /*
        $("#spiderHexagons").empty();
        $("#spiderContours").empty();
        $("#spiderContents").empty();
        $("#spiderTouchOverlay").empty();
        $("#spiderHexagons").offset({ top: topOffset, left: leftOffset });
        $("#spiderContours").offset({ top: topOffset, left: leftOffset });
        $("#spiderContents").offset({ top: topOffset, left: leftOffset });
        $("#spiderTouchOverlay").offset({ top: topOffset, left: leftOffset });
        $("#spiderHexagons").append(mySvgHexagons);
        $("#spiderContours").append(mySvgSpiderContours);
        $("#spiderContents").append(mySvgSpiderContents);
        $("#spiderTouchOverlay").append(mySvgSpiderTouchOverlay);
     */
    let eventRefdata: Array<any> = new Array<any>();

    for (let p = 0; p < this.spiderparameters.length; p++) {
      for (let k = 0; k < radiusList.length; k++) {
        var valueElementId = '#analysis__' + this.spiderparameters[p] + k;
        var overlayElementId = '#kidney_hexa_' + k + '_' + p;
        var eventData = {
          parameter: this.spiderparameters[p],
          parametervalue: k
        };
        eventRefdata.push({
          valueElementId: valueElementId,
          overlayElementId: overlayElementId,
          eventData: eventData
        });
        /*
                $(overlayElementId).on("click", eventdata, onspiderevent);
                $(overlayElementId).on("mousedown", eventdata, onspiderevent);
         */
        /*
                $('#kidney_hexa_' + k).hover(function(event) {
                 // console.log('hover in on ' + event.target.id);
                }, function(event) {
                  // console.log('hover out of ' + event.target.id);
                });
        */
      }
    }
    let result = {
      svgHexagons: mySvgHexagons,
      svgSpiderContents: mySvgSpiderContents,
      svgSpiderTouchOverlay: mySvgSpiderTouchOverlay,
      content: [
        {
          name: 'svgHexagons',
          value: mySvgHexagons
        },
        {
          name: 'svgSpiderContours',
          value: mySvgSpiderContours
        },
        {
          name: 'svgSpiderContents',
          value: mySvgSpiderContents
        },
        {
          name: 'svgSpiderTouchOverlay',
          value: mySvgSpiderTouchOverlay
        }
      ],
      eventRefdata: eventRefdata
    };
    return result;
  }
  private onspiderevent(event) {
    console.log(event.type + ' on point for value ' + event.data.parameter + ', ' + event.data.parametervalue);
    this.updateAromaValue(event.data.parameter, event.data.parametervalue);
  }
  private updateAromaValue(parameter, parametervalue) {
    console.log('click on point for value ' + parameter + ', ' + parametervalue);
    /*
        $('.radiosforbuttons-analysis__' + parameter).removeClass('active');
        $('.radiosforbuttons-analysis__' + parameter + '[value="' + parametervalue + '"]').addClass('active');
        $('analysis__' + parameter).prop( "checked", false );
        $('#analysis__' + parameter + parametervalue).prop( "checked", true );
        formAnalysisData[parameter] = parametervalue;
        this.generateSpider(formAnalysisData);
    */
  }
  private generateSpiderContours(viewPortHeight, viewPortWidth) {
  }

  private generateSpiderHexagons(radiusList, viewPortHeight, viewPortWidth, spiderRadius, center) {
    var mysvg = '<svg height="' + viewPortHeight + '" width="' + viewPortWidth + '" viewport="0 0 ' + viewPortWidth + ' ' + viewPortHeight + '" >';

    for (let k = 0; k < radiusList.length; k++) {
      var radius = radiusList[k];
      var corners = this.spidercorners[k];

      // draw hexagon
      var clickzoneRadius = spiderRadius / 12;
      if (k == radiusList.length - 1) {
        mysvg = mysvg + this.drawHexagon('hexa_' + k, center.x, center.y, radius,
          'opacity:0.75;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#5d4c44;stroke-width:2.32676554;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1',
        );
      }
      else {
        mysvg = mysvg + this.drawHexagon('hexa_' + k, center.x, center.y, radius,
          'opacity:0.75;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#5d4c44;stroke-width:1.28845692;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1',
        );
      }

      // draw diagonals only for outer hexagon
      if (k == radiusList.length - 1) {
        for (let p = 0; p < corners.length / 2; p++) {
          var diagonal = '<path d="M' + corners[p].x + ' ' + corners[p].y +
            ' L' + corners[p + corners.length / 2].x +
            ' ' + corners[p + corners.length / 2].y + '"' +
            ' stroke="black" stroke-width="0.3" fill="none"' +
            ' />';
          mysvg = mysvg + diagonal;
        }
      }
    }
    mysvg = mysvg + '</svg>';

    return mysvg;
  }

  public drawHexagon(hexagonId, centerX, centerY, radius, style) {
    var hexagonCorners = [
      { x: centerX - radius, y: centerY },
      { x: centerX - radius / 2, y: centerY - radius * Math.sin(60 * Math.PI / 180.0) },
      { x: centerX + radius / 2, y: centerY - radius * Math.sin(60 * Math.PI / 180.0) },
      { x: centerX + radius, y: centerY },
      { x: centerX + radius / 2, y: centerY + radius * Math.sin(60 * Math.PI / 180.0) },
      { x: centerX - radius / 2, y: centerY + radius * Math.sin(60 * Math.PI / 180.0) }
    ];
    var myHexagon = '<polygon id="' + hexagonId + '" points="';
    for (let p = 0; p < hexagonCorners.length; p++) {
      myHexagon = myHexagon + hexagonCorners[p].x + ',' + hexagonCorners[p].y + " ";
    }
    myHexagon = myHexagon + '" style="' + style + '"';
    myHexagon = myHexagon + ' />';
    // console.log('drawHexagon, returning hexagon: ' + myHexagon);
    return myHexagon;
  }
  public drawIcon(x, y, svgPath, width, height) {
    var myIcon = '<g transform="translate(' + x + ',' + y + ')">' +
      '<image xlink:href="' + svgPath + '" ' + ' " height="' + height + '" width="' + width + '"' + '/>' +
      '</g>';
    return myIcon;
  }
  public drawAromaText(wordstring, x, y) {
    var words: Array<string> = wordstring.split(' ');
    var myAromaText = this.makeBinaryParameterText(x, y, words);
    return myAromaText;
  }
  private makeBinaryParameterText(x, y, words: Array<string>) {
    let fontSize: number = Math.round(window.innerWidth / 46);
    let lineHeight: number = fontSize / 7.2;

    var aromaTextStyle = 'font-weight:bold;font-size:' + fontSize + 'px;fill:#5d4c44;line-height:' + lineHeight + ';font-family:\'Century Gothic\';text-align:center;text-anchor:middle;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;fill-opacity:1;stroke:none;stroke-width:0.49262366';

    var result = '';
    if (words.length == 1) {
      result = result + this.makeText(x, y + 1.5, words[0], aromaTextStyle, 'middle');
    }
    else {
      for (let i = 0; i < words.length; i++) {
        result = result + this.makeText(x, y + i * (fontSize - 1) - 3, words[i], aromaTextStyle, 'middle');
      }
    }
    return result;
  }
  public drawLegendLine(x, y): string {
    let lineStyle: string = 'stroke:#ff0058;stroke-width:0.49262366;';
    let result: string = '<polyline points="' + x + ',' + y + ' ' + (x + 10) + ',' + (y - 10) + ' ' + (x + 10) + ',' + (y - 10) + '" ' +
      'style="' + lineStyle + '" />';

    return result;
  }
  public drawLegendText(wordstring, x, y, isActive: boolean) {
    var words: Array<string> = wordstring.split(' ');
    var myAromaText = this.makeLegendText(x, y, words, isActive);
    return myAromaText;
  }
  private makeLegendText(x, y, words: Array<string>, isActive: boolean) {
    var aromaTextStyle = (isActive ?
      'font-weight:bold;font-size:12px;fill:#5d4c44;line-height:1.25;font-family:\'Century Gothic\';text-align:center;text-anchor:middle;letter-spacing:0px;word-spacing:0px;' :
      'font-weight:normal;font-size:11px;fill:#aaaaaa;line-height:1.25;font-family:\'Century Gothic\';text-align:center;text-anchor:middle;letter-spacing:0px;word-spacing:0px;');

    var result = '';
    if (words.length == 1) {
      result = result + this.makeText(x, y + 1.5, words[0], aromaTextStyle, 'middle');
    }
    else {
      for (let i = 0; i < words.length; i++) {
        result = result + this.makeText(x, y + i * 8 - 3, words[i], aromaTextStyle, 'middle');
      }
    }
    return result;
  }
  private makeText(x, y, word, style, textAnchor) {
    var maxWordLength = 14;
    var maxCharWithoutScaling = 7;
    var toPrint: string = this.truncate(word, maxWordLength);

    var xScale = 1.0;
    if (toPrint.length > maxCharWithoutScaling) {
      xScale = maxCharWithoutScaling / toPrint.length;
    }
    var transformation = 'matrix(' + xScale + ', 0, 0, 1.0, ' + x + ',' + y + ')';

    var result = '<text text-anchor="' + textAnchor + '"';

    result += ' transform="' + transformation + '"';
    result += ' style="' + style + '"';
    result += '>';
    result += toPrint;
    result += '</text>';

    return result;
  }
  private truncate(word, maxWordLength) {

    var result = word;
    if (word.length > maxWordLength) {
      result = word.substring(0, maxWordLength - 1) + '..';
    }
    return result;
  }

  private generateSpiderTouchOverlay(radiusList, viewPortHeight, viewPortWidth, spiderRadius, center) {
    var mysvg = '<svg height="' + viewPortHeight + '" width="' + viewPortWidth + '" viewport="0 0 ' + viewPortWidth + ' ' + viewPortHeight + '" >';

    for (let k = 0; k < radiusList.length; k++) {
      var radius = radiusList[k];

      // draw hexagon
      var clickzoneRadius = spiderRadius / 12;
      if (k == radiusList.length - 1) {
        mysvg = mysvg + this.drawTouchOverlay('hexa_' + k, center.x, center.y, radius,
          'opacity:0.75;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#5d4c44;stroke-width:2.32676554;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1',
          null, clickzoneRadius);
      }
      else {
        mysvg = mysvg + this.drawTouchOverlay('hexa_' + k, center.x, center.y, radius,
          'opacity:0.75;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#5d4c44;stroke-width:1.28845692;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1',
          null, clickzoneRadius);
      }

    }
    mysvg = mysvg + '</svg>';

    return mysvg;
  }
  private drawTouchOverlay(hexagonId, centerX, centerY, radius, style, clickHandler, clickzoneRadius) {
    var hexagonCorners = [
      { x: centerX - radius, y: centerY },
      { x: centerX - radius / 2, y: centerY - radius * Math.sin(60 * Math.PI / 180.0) },
      { x: centerX + radius / 2, y: centerY - radius * Math.sin(60 * Math.PI / 180.0) },
      { x: centerX + radius, y: centerY },
      { x: centerX + radius / 2, y: centerY + radius * Math.sin(60 * Math.PI / 180.0) },
      { x: centerX - radius / 2, y: centerY + radius * Math.sin(60 * Math.PI / 180.0) }
    ];

    var myTouchOverlay = '';
    for (let p = 0; p < hexagonCorners.length; p++) {
      var myclickzone = this.drawKidney(hexagonId + '_' + p, hexagonId, hexagonCorners[p].x, hexagonCorners[p].y, clickzoneRadius, radius, 30 + 60 * (p + 1));
      myTouchOverlay = myTouchOverlay + myclickzone;
    }

    return myTouchOverlay;
  }
  private drawKidney(hexId, styleClass, centerX, centerY, verticalRadius, hexagonRadius, rotationAngle) {
    var cornerCorrection = Math.sin(60 * Math.PI / 180.0);
    var myKidney = '<g transform="rotate(' + rotationAngle + ' ' + centerX + ' ' + centerY + ')">' +
      '<polygon id="kidney_' + hexId + '" class="kidney_' + styleClass + '" points=" ' +
      centerX + ',' + (centerY - verticalRadius) + ' ' +
      (centerX + (hexagonRadius / 2 * cornerCorrection)) + ',' + (centerY - verticalRadius - verticalRadius * cornerCorrection) + ' ' +
      (centerX + (hexagonRadius / 2 * cornerCorrection)) + ',' + (centerY + verticalRadius - verticalRadius * cornerCorrection) + ' ' +
      centerX + ',' + (centerY + verticalRadius) + ' ' +
      (centerX - (hexagonRadius / 2 * cornerCorrection)) + ',' + (centerY + verticalRadius - verticalRadius * cornerCorrection) + ' ' +
      (centerX - (hexagonRadius / 2 * cornerCorrection)) + ',' + (centerY - verticalRadius - verticalRadius * cornerCorrection) + ' ' +
      '' + // close path
      '" stroke="blue" stroke-width="2" fill="#ffcc00" style="opacity:0;" />' +
      '</g>';
    return myKidney;
  }
  private generateSpiderContents(analysis, viewPortHeight, viewPortWidth) {

    if (analysis) {

      var spidervalues = new Array(0, 0, 0, 0, 0, 0);
      for (let ir = 0; ir < this.spiderparameters.length; ir++) {
        spidervalues[ir] = this.getSpiderValue(analysis[this.spiderparameters[ir]]);
      }
      var colourRGB = analysis.colourRGB;
      //console.log('colourRGB = ' + colourRGB);

      var contentsvg = '<svg height="' + viewPortHeight + '" width="' + viewPortWidth + '" viewport="0 0 ' + viewPortWidth + ' ' + viewPortHeight + '" >';
      contentsvg = contentsvg + '<polygon points="';
      for (let is = 0; is < this.spiderparameters.length; is++) {
        // console.log('Value for parameter ' + this.spiderparameters[is] + ' = ' + spidervalues[is]);
        //
        // tweak to avoid js error
        if (spidervalues[is] > 4) spidervalues[is] = 4;
        contentsvg = contentsvg + this.spidercorners[spidervalues[is]][is].x + ',' + this.spidercorners[spidervalues[is]][is].y + " ";
      }
      contentsvg = contentsvg + '" style="opacity:0.9;fill:' + colourRGB + ';fill-opacity:0.95297032;stroke:#ffc000;stroke-width:3.89763832;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" ';
      contentsvg = contentsvg + ' />';
      contentsvg = contentsvg + '</svg>';
      return contentsvg;
    }
    else {
      return '<svg height="' + viewPortHeight + '" width="' + viewPortWidth + '">' +
        '<rect x="10" y="10" width="100" height="100"/>' +
        '</svg>';
    }
  }
  private getSpiderValue(inputValue) {
    if (inputValue) {
      if (inputValue != null) {
        return inputValue;
      }
    }
    return 0;
  }

}
